import { Link } from '@morressier/alembic';
import React from 'react';
import PrivateAssetLink from 'src/components/PrivateAssetLink/PrivateAssetLink';

const isPrivateAssetUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return (
      parsed.hostname === 'storage.googleapis.com' &&
      !url.includes('morressier-assets-')
    );
  } catch {
    return false;
  }
};

export const parseStringWithLinks = (input: string, privateAssetType?: string): React.ReactNode => {
  return input.split(/(\[.*?\]\(.*?\))/g).map((part, i) => {
    const match = part.match(/\[(.*?)\]\((.*?)\)/);
    if (match) {
      const [, text, url] = match;

      if (!url || !text) {
        return <React.Fragment key={i}>{part}</React.Fragment>;
      }

      if (url === '#') {
        return (
          <Link
            key={i}
            href="#"
            variant="secondary"
            onClick={e => e.preventDefault()}
          >
            {text}
          </Link>
        );
      }

      if (privateAssetType && privateAssetType === "private" || isPrivateAssetUrl(url)) {
        return <PrivateAssetLink key={i} url={url} text={text} />;
      }

      return (
        <Link key={i} href={url} variant="secondary" target="_blank">
          {text}
        </Link>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};
